// areas
export const HOME_AREAS = [
  "Кухня",
  "Спальня / Дитяча",
  "Вітальня",
  "Ванна / Санвузол",
  "Передпокій / Коридор",
  "Кабінет / Офіс",
  "Балкон / Тераса / Сад",
  "Меблі",
  "Текстиль і килими",
  "Штори і карнизи",
  "Декор і дизайн",
  "Зберігання та організація",
  "Засоби та догляд",
  "Інше",
];

// sections by area
const SECTIONS_BY_AREA = {
  "Кухня": [
    "Посуд (столовий/кухонний/кава/чай/зберігання)",
    "Кухонне приладдя",
    "Текстиль кухні (скатертини/рушники/фартухи/подушки на стільці)",
    "Зберігання (ємності/органайзери/плівка/фольга/пакети)",
    "Декор (кухня)",
  ],
  "Спальня / Дитяча": [
    "Постіль і наматрацники",
    "Подушки і ковдри",
    "Пледи / Покривала",
    "Декор (спальня/дитяча)",
  ],
  "Вітальня": ["Текстиль (подушки/пледи)", "Декор (вітальня)"],
  "Ванна / Санвузол": [
    "Текстиль (рушники/килими для ванної)",
    "Аксесуари та зберігання (ванна)",
  ],
  "Передпокій / Коридор": [
    "Меблі (передпокій)",
    "Зберігання взуття / Органайзери",
    "Декор (передпокій)",
  ],
  "Кабінет / Офіс": [
    "Меблі (офіс)",
    "Організація робочого простору",
    "Декор (офіс)",
  ],
  "Балкон / Тераса / Сад": [
    "Кашпо / Вазони / Штучні рослини",
    "Меблі (сад/тераса)",
    "Декор (вуличний)",
  ],

  "Меблі": [
    "Корпусні меблі (тумби/комоди/столики/шафи/стелажі/полиці/гарнітури)",
    "Мʼякі меблі (дивани/крісло/пуфи/безкаркасні)",
    "Ліжка і матраци",
    "Меблі для кухні",
    "Меблі для передпокою",
    "Меблі для офісу",
    "Дзеркала",
    "Меблева фурнітура",
  ],
  "Текстиль і килими": [
    "Постільна білизна",
    "Наматрацники",
    "Подушки і ковдри",
    "Пледи / Покривала",
    "Декоративні подушки",
    "Рушники",
    "Скатертини / Серветки",
    "Килими / Доріжки / Килимки",
  ],
  "Штори і карнизи": [
    "Карнизи",
    "Штори / Тюль",
    "Ролети / Жалюзі",
    "Аксесуари для штор",
  ],
  "Декор і дизайн": [
    "Свічки та свічники",
    "Аромати для дому",
    "Фоторамки / Картини / Постери",
    "Вази / Кашпо / Настільний декор / Фігурки / Скриньки",
    "Годинники (настінні/настільні)",
    "Ключниці / Ікони",
  ],
  "Зберігання та організація": [
    "Коробки / Органайзери / Кошики",
    "Вішалки / Плічки / Чохли",
    "Вакуумні пакети / Мішки для прання",
    "Сушарки для білизни / Прасувальні дошки / Аксесуари",
    "Швабри / Щітки / Совки / Відра",
    "Контейнери / Відра для сміття",
  ],
  "Засоби та догляд": [
    "Для прибирання (універсальні/кухня/санвузол/підлога)",
    "Для прання (порошки/гелі/кондиціонери/відбілювачі/аксесуари)",
    "Для посуду (ручне/для ПММ)",
    "Освіжувачі повітря",
    "Догляд за взуттям / Засоби від комах",
    "Витратні матеріали (рукавички/губки/серветки/паперові рушники/туалетний папір/одноразовий посуд/харчова упаковка)",
  ],
  "Інше": ["Інші товари для дому"],
};

// subcategories
const SUBCATS_BY_SECTION = {
  "Посуд (столовий/кухонний/кава/чай/зберігання)": [
    "Столовий",
    "Кухонний",
    "Для кави та чаю",
    "Для зберігання",
  ],
  "Кухонне приладдя": [],
  "Текстиль кухні (скатертини/рушники/фартухи/подушки на стільці)": [],
  "Зберігання (ємності/органайзери/плівка/фольга/пакети)": [],
  "Декор (кухня)": [],
  "Постіль і наматрацники": [],
  "Подушки і ковдри": [],
  "Пледи / Покривала": [],
  "Декор (спальня/дитяча)": [],
  "Текстиль (подушки/пледи)": [],
  "Декор (вітальня)": [],
  "Текстиль (рушники/килими для ванної)": [],
  "Аксесуари та зберігання (ванна)": [],
  "Меблі (передпокій)": [],
  "Зберігання взуття / Органайзери": [],
  "Декор (передпокій)": [],
  "Меблі (офіс)": [],
  "Організація робочого простору": [],
  "Декор (офіс)": [],
  "Кашпо / Вазони / Штучні рослини": [],
  "Меблі (сад/тераса)": [],
  "Декор (вуличний)": [],
  "Постільна білизна": [],
  "Наматрацники": [],
  "Пледи / Покривала": [],
  "Декоративні подушки": [],
  "Рушники": [],
  "Скатертини / Серветки": [],
  "Килими / Доріжки / Килимки": [],
  "Карнизи": [],
  "Штори / Тюль": [],
  "Ролети / Жалюзі": [],
  "Аксесуари для штор": [],
  "Свічки та свічники": [],
  "Аромати для дому": [],
  "Фоторамки / Картини / Постери": [],
  "Вази / Кашпо / Настільний декор / Фігурки / Скриньки": [],
  "Годинники (настінні/настільні)": [],
  "Ключниці / Ікони": [],
  "Коробки / Органайзери / Кошики": [],
  "Вішалки / Плічки / Чохли": [],
  "Вакуумні пакети / Мішки для прання": [],
  "Сушарки для білизни / Прасувальні дошки / Аксесуари": [],
  "Швабри / Щітки / Совки / Відра": [],
  "Контейнери / Відра для сміття": [],
  "Для прибирання (універсальні/кухня/санвузол/підлога)": [],
  "Для прання (порошки/гелі/кондиціонери/відбілювачі/аксесуари)": [],
  "Для посуду (ручне/для ПММ)": [],
  "Освіжувачі повітря": [],
  "Догляд за взуттям / Засоби від комах": [],
  "Витратні матеріали (рукавички/губки/серветки/паперові рушники/туалетний папір/одноразовий посуд/харчова упаковка)": [],
  "Інші товари для дому": [],
};

// fields
export const homeComfortFields = (attrs) => {
  const a = attrs || {};
  const area = a.area || "";
  const section = a.section || "";

  const areaOnly = [
    {
      name: "area",
      label: "Зона / Кімната *",
      type: "select",
      options: HOME_AREAS,
      required: true,
    },
  ];
  if (!area) return areaOnly;

  const sectionOnly = [
    ...areaOnly,
    {
      name: "section",
      label: "Розділ",
      type: "select",
      options: SECTIONS_BY_AREA[area] || [],
      required: false,
    },
  ];
  if (!section) return sectionOnly;

  const subcats = SUBCATS_BY_SECTION[section] || [];
  if (!subcats.length) return sectionOnly;

  return [
    ...sectionOnly,
    {
      name: "subcategory",
      label: "Підкатегорія",
      type: "select",
      options: subcats,
      required: false,
    },
  ];
};
